import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, TextField, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { TRAVELS } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import EditPenIcon from "src/svgComponents/EditPenIcon";
import BinIcon from "src/svgComponents/BinIcon";
import CloseIcon from '@mui/icons-material/Close';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useTheme } from '@mui/material/styles';
import { useMutation } from "react-query";
import FormHelperText from "@mui/material/FormHelperText";
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import { fDate } from "src/utils/formatTime";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange } from 'react-date-range';
import moment from "moment";
import ShowImage from "../common/ShowImage";
import AppTooltip from "src/components/common/AppTooltip";
import useStore from 'src/contexts/AuthProvider'
import DefaultImage from "../../assets/images/Default_image.png";
const _ = require('lodash');

const Travel = () => {
    const [tableData, setTableData] = useState([]);
    const permissionsData = useStore(state => state.permissions);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const axiosPrivate = useAxiosPrivate();
    const [openModal, setOpenModal] = useState(false);
    const [profilePic, setProfilePic] = useState("");
    const [imageName, setImageName] = useState();
    const [showImage, setShowImage] = useState();
    const [modelTitle, setmodelTitle] = useState("");
    const [filterName, setFilterName] = useState('');
    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: null,
            key: 'selection'
        }
    ]);

    const [disable, setDisable] = useState(false);
    const [Id, setId] = useState("");
    const { enqueueSnackbar } = useSnackbar();
    const [deleteId, setdeleteId] = useState("");
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const [loading, setLoding] = useState(true);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [uploadedImage, setUploadedImage] = useState();
    const [flag, setFlag] = useState();

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff',
        },
        '&:nth-of-type(even)': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
        },
        // hide last border
        '& td, & th': {
            border: 0,
        },
    }));

    const TABLE_HEAD = [
        { id: 'title', label: 'Title', alignRight: false },
        { id: 'image', label: 'Image', alignRight: false },
        { id: 'description', label: 'Description', alignRight: false },
        { id: 'start_date', label: 'Start Date', alignRight: false },
        { id: 'end_date', label: 'End Date', alignRight: false },
        { id: 'price', label: 'MRP', alignRight: false },
        { id: 'discount', label: 'Discount', alignRight: false },
        { id: 'offerPrice', label: 'Offer Price', alignRight: false },
        { id: 'status', label: 'Status', alignRight: false },
        { id: 'action', label: 'Action', alignRight: false },
    ];

    async function getTravels(page, filterName) {
        const response = await axiosPrivate.get(TRAVELS.getTravel, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
        return response.data[0];
    }

    const { data: travelList, refetch } = useQuery(['travelList', page, filterName], () => getTravels(page, filterName), { keepPreviousData: true, })

    useEffect(() => {
        if (travelList) {
            setTableData(travelList.data);
            setRowsPerPage(travelList?.metadata.length != 0 ? travelList?.metadata[0].limit : 10);
        }
        if (travelList?.metadata.length != 0 && travelList?.metadata[0].hasMoreData == true) {
            getTravels(page + 1);
        }
        setTimeout(() => {
            setLoding(false);
        }, 1000)
    }, [travelList])

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setTimeout(() => {
            refetch();
        }, 500);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleFilterByName = (event) => {
        setFilterName(event.target.value.trim());
        setPage(0);
        getTravels(page, filterName)
        refetch();
    };
    // async function getFoodCategory() {
    //     const response = await axiosPrivate.get(FOOD_ITEMS.getFoodCategory, { params: { page: 1 } })
    //     return response.data;
    // }
    // const { data: foodCategorys } = useQuery(['foodCategorys'], () => getFoodCategory(), { keepPreviousData: true, })
    // useEffect(() => {
    //     if (foodCategorys !== undefined) {
    //         setFoodCategory(foodCategorys[0].data)
    //     }
    // }, [foodCategorys])

    // async function getFoodMenu() {
    //     const response = await axiosPrivate.get(FOOD_ITEMS.getFoodMenu, { params: { page: 1 } })
    //     return response.data;
    // }
    // const { data: foodMenu } = useQuery(['foodMenu'], () => getFoodMenu(), { keepPreviousData: true, })
    // useEffect(() => {
    //     if (foodMenu !== undefined) {
    //         setFoodMenuData(foodMenu[0].data)
    //     }
    // }, [foodMenu])

    const completedSchema = Yup.object().shape({
        title: Yup.string()
            .min(2, "Title can set of between 2 and 50 characters!")
            .max(50, "Title can set of between 2 and 50 characters!")
            .required("Title is required"),
        price: Yup.number()
            .required('price is required')
            .min(10, "price must be greater than 10")
            .max(99999, "price must be less than 99999"),
        offerPrice: Yup.number()
            .required('offer price is required')
            .min(10, "offer price must be greater than 10")
            .max(99999, "offer price must be less than 99999"),
        // start_date: Yup.string().required('Start Date is required'),
        // end_date: Yup.string().required('End Date is required'),
        description: Yup.string().required('Description is required'),
        // image: Yup.string().required('Image is required'),
    });

    const handleUploadImage = async () => {
        const formData = new FormData();
        formData.append('image', uploadedImage)
        const imageData = await axiosPrivate.post(TRAVELS.uploadImage, formData)
        setImageName(imageData?.data?.file_name)
        setFieldValue("image", imageData?.data?.file_name)
        return imageData?.data?.file_name;
    }

    const formik = useFormik({
        initialValues: {
            title: "",
            description: "",
            start_date: "",
            end_date: "",
            price: "",
            discount: "",
            offerPrice: "",
            image: ""
        },
        validationSchema: completedSchema,
        onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
            let image_name = '';
            if (!imageName) {
                if (flag === 'asd') {
                    image_name = await handleUploadImage();
                }
            } else {
                image_name = imageName
            }
            const informationObj = {
                title: values.title,
                start_date: moment(state[0].startDate).format("YYYY-MM-DD"),
                end_date: moment(state[0].endDate).format("YYYY-MM-DD"),
                description: values.description,
                price: values.price,
                discount: values.discount,
                offerPrice: values.offerPrice,
                image: image_name
            };
            if (Id == "") {
                await travelAdd(informationObj);
            } else {
                await travelUpdate(informationObj);
            }
            // setParentId("");
            resetForm();
            setSubmitting(false);
        },
    });

    const { mutateAsync: travelAdd } = useMutation(
        async (data) => {
            return await axiosPrivate.post(TRAVELS.travelAdd, data)
        },
        {
            onSuccess: ({ data }) => {
                enqueueSnackbar(data.message, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                    autoHideDuration: 2000,
                });
                handleCloseModal();
                refetch();
            },
            onError: (error) => {
                const errorData = error.response.data.errors;
                if (error.response?.data?.message) {
                    enqueueSnackbar(error.response?.data?.message, {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                        autoHideDuration: 2000,
                    });
                }
                Object.keys(errorData).forEach((key) => {
                    if (key === "image") {
                        setFieldError(key, errorData[key]);
                    }
                    else {
                        setFieldError(key, errorData[key]);
                    }
                });
            },
        }
    );

    const { mutateAsync: travelUpdate } = useMutation(
        async (data) => {
            return await axiosPrivate.patch(TRAVELS.updateTravel + "/" + Id, data)
        },
        {
            onSuccess: ({ data }) => {
                refetch();
                enqueueSnackbar(data.message, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                    autoHideDuration: 2000,
                });
                handleCloseModal();
            },
            onError: (error) => {
                const errorData = error.response.data.errors;
                if (error.response?.data?.message) {
                    enqueueSnackbar(error.response?.data?.message, {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                        autoHideDuration: 2000,
                    });
                }
                Object.keys(errorData).forEach((key) => {
                    if (key === "name") {
                        setFieldError("name", errorData[key]);
                    } else {
                        setFieldError(key, errorData[key]);
                    }
                });
            },
        }
    );

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function applySortFilter(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });

        return stabilizedThis.map((el) => el[0]);
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - categoryList?.metadata[0].total) : 0;

    const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

    const handleClose = () => {
        setOpen(false);
        setShowImage('');
    };

    const deleteTravel = async () => {
        const response = await axiosPrivate.delete(TRAVELS.deleteTravel + '/' + deleteId)
        if (response.status == 200) {
            enqueueSnackbar(response?.data?.message, {
                variant: "success",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        } else {
            enqueueSnackbar("Something went wrong", {
                variant: "error",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
        refetch();
        handleClose();
    };

    const handleOpenModalAdd = () => {
        setFieldValue('title', "")
        setFieldValue('description', "")
        setFieldValue('discount', "")
        setFieldValue('start_date', "")
        setFieldValue('end_date', "")
        setFieldValue('price', "")
        setFieldValue('offerPrice', "")
        setFieldValue('image', "")
        setState([{
            startDate: null,
            endDate: null,
            key: 'selection'
        }]);
        setShowImage('');
        setProfilePic('');
        setId('')
        setmodelTitle('Travel Add')
        setDisable(false);
        setOpenModal(true);
    };

    const handleOpenModalUpdate = (row) => {
        if (row.discount === undefined) {
            setFieldValue('offerPrice', row.price)
        } else {
            setFieldValue('offerPrice', row.offerPrice)
        }
        setProfilePic('')
        setFieldValue("title", row.title)
        setFieldValue("description", row.description)
        setFieldValue('price', row.price)
        setFieldValue('discount', row.discount)
        setFieldValue('image', row.image)
        setState([{
            startDate: new Date(row.start_date),
            endDate: new Date(row.end_date),
            key: 'selection'
        }]);
        setImageName(row.image)
        setShowImage(row.image)
        setId(row._id)
        setmodelTitle('Travel Update')
        setDisable(true);
        setOpenModal(true);
    };

    const handleClickOpen = (categoryId, categoryType) => {
        setdeleteId(categoryId);
        setOpen(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleProfilePicOnChange = async (ev) => {
        if (ev.type.includes("image")) {
            setUploadedImage(ev);
            let userImgSrc = URL.createObjectURL(ev);
            setProfilePic(userImgSrc);
            setImageName('')
        }
    };

    const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, setFieldTouched } = formik;
    // if (isLoading) return <LoadingScreen />
    // const handleFoodCategoryOnChange = (event) => {
    //     setFoodCategoryId(event.target.value);
    // };

    // const handleFoodMenuOnChange = (event) => {
    //     setFoodMenuId(event.target.value);
    // };

    const changeStatus = async (id) => {
        const response = await axiosPrivate.put(TRAVELS.changeTravelStatus + '/' + id)
        if (response?.data?.message) {
            enqueueSnackbar(response?.data?.message, {
                variant: "success",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
        refetch()
    }

    const setDiscount = (e) => {
        let price = getFieldProps("price");
        let discount = e.target.value;
        setFieldValue('discount', discount)
        let discountInRs = price.value * discount / 100;
        let offerPrice = price.value - discountInRs;
        setFieldValue('offerPrice', offerPrice)
    }

    const setPrice = (e) => {
        let discount = getFieldProps("discount");
        let price = e.target.value;
        setFieldValue('price', price)
        let discountInRs = price * discount.value / 100;
        let offerPrice = price - discountInRs;
        if (discount.value) {
            setFieldValue('offerPrice', offerPrice)
        } else {
            setFieldValue('offerPrice', price)
        }
    }

    return (
        <>
            <LoadingScreen loading={loading} />
            <div className="dashboard_header mb-4">
                <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Travel</h4>
                <Box className="d-flex align-items-center">
                    <Paper component="form" className='dashboard_searchbox' sx={{ minWidth: '380px' }}>
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                        <InputBase
                            fullWidth
                            sx={{ flex: 1 }}
                            placeholder="Search Travel..."
                            onChange={(e) => handleFilterByName(e)}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                        />
                    </Paper>
                    <Stack direction={"row"} className="d-flex align-items-center ms-lg-4 ms-2" spacing={2}>
                        {permissionsData?.travels?.substring(1, 2) == "1" ?
                            <AppTooltip title="Add Travel" placement="bottom">
                                <Button className="dashboard_light_bg_icon_btn" onClick={handleOpenModalAdd} ><AddCircleOutlineOutlinedIcon style={{ fontSize: 18, color: "#fff" }} /></Button>
                            </AppTooltip> : ""}
                    </Stack>
                </Box>
            </div>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" className='m-auto'>
                    {"Are you sure you want to delete?"}
                </DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions className='m-auto'>
                    <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className="theme_button" variant="contained" onClick={() => deleteTravel()} autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            <Card>
                <TableContainer>
                    <Table>
                        <UserListHead
                            headLabel={TABLE_HEAD}
                            rowCount={travelList?.data?.length}
                            onRequestSort={handleRequestSort}
                        />
                        {filteredUsers?.length > 0 ?
                            <TableBody>
                                {filteredUsers.map((row) => {
                                    return (
                                        <StyledTableRow key={row._id}>
                                            <TableCell component="th" scope="row">
                                                {row.title}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <img src={row.image ? process.env.REACT_APP_PROFILE_URL + 'travelmenu/' + row.image : DefaultImage} height="53px" width="73px" alt="profile" />
                                            </TableCell>
                                            <TableCell align="left"> {row.description}</TableCell>
                                            <TableCell align="left"> {fDate(row.start_date)}</TableCell>
                                            <TableCell align="left"> {fDate(row.end_date)}</TableCell>
                                            <TableCell align="left"> {row.price ?? '-'}</TableCell>
                                            <TableCell align="left"> {row.discount ?? '-'}</TableCell>
                                            <TableCell align="left"> {row.offerPrice ?? '-'}</TableCell>
                                            {/* <TableCell align="left"> {moment(row.createdAt).format("MMM DD YYYY h:mm A")}</TableCell> */}
                                            <TableCell>
                                                <Stack direction="row" spacing={3}>
                                                    {
                                                        row.status == 1 ? <Chip variant="contained" label="Enable" className="app_status_chip accepted" onClick={() => changeStatus(row._id)} /> : <Chip variant="contained" className="app_status_chip invalid" label="Disable" onClick={() => changeStatus(row._id)} />
                                                    }
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={3}>
                                                    {permissionsData?.travels?.substring(3, 4) == "1" ?
                                                        <AppTooltip title="Edit Travel" placement="bottom">
                                                            <Button sx={{ "&:hover": { bgcolor: "transparent" } }} onClick={() => handleOpenModalUpdate(row)} variant="text" className="user_list_row_btn"><EditPenIcon /></Button>
                                                        </AppTooltip> : ""}
                                                    {permissionsData?.travels?.substring(2, 3) == "1" ?
                                                        <AppTooltip title="Delete Travel" placement="bottom">
                                                            <Button variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id, "main")} ><BinIcon /></Button>
                                                        </AppTooltip> : ""}
                                                </Stack>
                                            </TableCell>
                                        </StyledTableRow>
                                    )
                                })}
                            </TableBody>
                            :
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                        <span className="app_text_16_semibold">No Data Found</span>
                                    </TableCell>
                                </TableRow>
                            </TableBody>}

                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    count={travelList?.metadata.length != 0 ? travelList?.metadata[0].total : 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h4>{modelTitle}</h4>
                        <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                            <CloseIcon style={{ color: '#fff' }} />
                        </Button>
                    </Box>
                </DialogTitle>
                <DialogContent className="custom_form_mui pt-2 travel_modal">
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <TextField
                                            label='Title'
                                            name='title'
                                            autoComplete='off'
                                            fullWidth
                                            variant='outlined'
                                            {...getFieldProps("title")}
                                            error={Boolean(touched.title && errors.title)}
                                            helperText={touched.title && errors.title}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <TextField
                                            label='Description'
                                            name='description'
                                            autoComplete='off'
                                            sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { minHeight: '3.5rem' } }}
                                            fullWidth
                                            multiline
                                            variant='outlined'
                                            {...getFieldProps("description")}
                                            error={Boolean(touched.description && errors.description)}
                                            helperText={touched.description && errors.description}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group mb-4">
                                        <TextField
                                            label='Price'
                                            name='price'
                                            type='number'
                                            autoComplete='off'
                                            fullWidth
                                            variant='outlined'
                                            {...getFieldProps("price")}
                                            onChange={(e) => setPrice(e)}
                                            error={Boolean(touched.price && errors.price)}
                                            helperText={touched.price && errors.price}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-4">
                                        <TextField label='Discount' name='discount' type='number' autoComplete='off' fullWidth variant='outlined'
                                            {...getFieldProps("discount")} onChange={(e) => setDiscount(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-4">
                                        <TextField
                                            label='Offer Price'
                                            name='offerPrice'
                                            type='number'
                                            autoComplete='off'
                                            fullWidth
                                            variant='outlined'
                                            {...getFieldProps("offerPrice")}
                                            error={Boolean(touched.offerPrice && errors.offerPrice)}
                                            helperText={touched.offerPrice && errors.offerPrice}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <DateRange
                                    editableDateInputs={true}
                                    onChange={item => setState([item.selection])}
                                    moveRangeOnFirstSelection={false}
                                    ranges={state}
                                />
                            </div>
                            <div className="col-lg-6">
                                <ShowImage modalId={Id} profilePic={profilePic} showImage={showImage} folderName="travelmenu/" />
                                <Button
                                    className="my-4 text-white app_bg_primary app_text_14_500 p-2"
                                    variant="contained"
                                    component="label"
                                    style={{ "borderRadius": 5 }}
                                >
                                    {Id ? 'Change Image' : 'Select Image'}
                                    <input
                                        hidden
                                        accept="image/*"
                                        onChange={(event) => {
                                            const files = event.target.files[0];
                                            if (files !== undefined) {
                                                setFlag('asd')
                                                handleProfilePicOnChange(files);
                                            }
                                        }}
                                        type="file"
                                    />
                                </Button>
                                <FormHelperText error>
                                    {errors.image}
                                </FormHelperText>
                            </div>
                            <div className="col">
                                <div className="col-md-8 m-auto">
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </FormikProvider>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default Travel
